import { useEffect, useState } from 'react';
import { avatarUrl } from '../../../config/images';

interface Props {
    userId?: number;
    avatarVersion?: number;
    className: string;
}

export function Avatar({ userId, avatarVersion, className }: Props): React.JSX.Element {
    const src = avatarUrl(userId, avatarVersion);
    const [failed, setFailed] = useState(false);

    useEffect(() => setFailed(false), [src]);

    if (!src || failed) {
        return <div className={className} />;
    }

    return <img className={className} src={src} alt="" onError={() => setFailed(true)} />;
}
